/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { useLocation } from 'js/lib/useRouter';

import { COOKIES_PAGE_SLUG } from 'bundles/about/AboutConstants';
import AboutSections from 'bundles/about/components/AboutSections';
import useAboutPageContentfulData from 'bundles/about/components/useAboutPageContentfulData';
import { getAboutPageContentfulSlug, getAboutPageMetatags } from 'bundles/about/utils';
import { renderLink } from 'bundles/about/utils/AboutUtils';
import { CourseraMetatags } from 'bundles/seo';

const styles = {
  cookiesPage: css`
    #ot-sdk-btn.ot-sdk-show-settings {
      color: var(--cds-color-interactive-primary);
      text-decoration: none;
      margin-bottom: var(--cds-spacing-200);
      display: block;
      font-weight: bold;
      font-size: var(--cds-font-size-body2);
      border: 0;
      padding: 0;
      background-color: transparent;

      &:hover {
        color: var(--cds-color-interactive-primary);
        text-decoration: underline;
        background-color: transparent;
      }
    }
  `,
};

export const AboutContentfulPage = () => {
  const location = useLocation();
  const pathname = location.pathname;
  const slug = getAboutPageContentfulSlug(pathname);
  const metatags = getAboutPageMetatags(pathname);
  const pageContent = useAboutPageContentfulData(slug);

  if (!pageContent?.slug) {
    return null;
  }

  return (
    <div data-testid={slug} css={[slug === COOKIES_PAGE_SLUG && styles.cookiesPage]}>
      <CourseraMetatags metaNameAndProperties={metatags} />
      {(pageContent.linksListCollection?.items?.length || 0) > 0 && (
        <div className="bt3-row-fluid coursera-about-nav">
          {pageContent.linksListCollection?.items?.map(renderLink)}
        </div>
      )}
      <div className="coursera-tos">
        <div className="coursera-tos-text">
          <AboutSections pageContent={pageContent} />
        </div>
      </div>
    </div>
  );
};

export default AboutContentfulPage;
